var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"scroll-up",class:{ 'scroll-up--controls-enabled': _vm.controlsEnabled },on:{"click":_vm.scrollUp}},[_c('img',{attrs:{"src":require(`@/assets/images/icons/scroll-up-icon.svg`)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }